import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { history } from '../../../store';

class BannerCarouselButton extends Component {
  state = {
    hover: false
  };

  getButtonStyle = () => {
    const { buttonColor, buttonTextColorWhenHover } = this.props;
    const { hover } = this.state;
    const hoveredButtonStyle = {
      color: buttonTextColorWhenHover,
      backgroundColor: buttonColor,
      borderColor: buttonColor,
    };
    const transparentButtonStyle = {
      color: buttonColor,
      backgroundColor: 'transparent',
      borderColor: buttonColor,
    };
    return hover ? {...hoveredButtonStyle} : {...transparentButtonStyle};
  };

  hoverOn = () => {
    this.setState({hover: true});
  };

  hoverOff = () => {
    this.setState({hover: false});
  };

  render() {
    const { buttonLabel, buttonLink, buttonColor } = this.props;
    const buttonClass = ['Red', 'Yellow', 'White', 'Grey'].includes(buttonColor) ? `${buttonColor.toLowerCase()}-ghost-btn` : 'red-ghost-btn'
    return (
      <Button
        className={buttonClass}
        onMouseEnter={this.hoverOn}
        onMouseLeave={this.hoverOff}
        style={this.getButtonStyle()}
        onClick={() => {
          if (buttonLink.match(/^https?:.*/i)) {
            window.open(buttonLink, '_blank');
          } else {
            history.push(buttonLink);
          }
        }}
      >
        {buttonLabel}
      </Button>
    );
  }
}

export default BannerCarouselButton;



// WEBPACK FOOTER //
// ./src/components/home/banner-carousel/banner-carousel-button.jsx